// extracted by mini-css-extract-plugin
export default {"Image":"ProductCard_Image__dtpT+","Card":"ProductCard_Card__LHrw8","Info":"ProductCard_Info__PzHTZ"};